import { RESOURCE_NAME } from '@esentai/core/features/giftCertificates/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadGiftCertificates = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateGiftCertificates = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateGiftCertificates = authorizeIf(canUpdate(RESOURCE_NAME));
